<template>
  <div class="BackgroundContainer" :style="{'background-image': 'url('+img+')', 'background-size': size, 'background-position': position, 'background-attachment': attachment, 'height': height}" :class="{}">

      <slot></slot>

  </div>
</template>

<script>

//import component from '@assets/components/component.vue'

export default {
  name: 'BackgroundContainer',
  components: {
    //component
  },
  props: {
    filename: String,
    size: String,
    position: String,
    attachment: String,
    height: {type: String, default: '100%'}
  },
  computed: {
    img: function () {
      return require('@/assets/images/' + this.filename);
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.BackgroundContainer{
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  /*background-image: url('~@/assets/images/flygvyboras.jpg');*/

  display: flex;
  align-items: center;
  justify-content: center;
}

img{
}

.fillw img{
  width: 100%;
}

.fillh{
}

.fillh img{
  height: 100%;
}

</style>
